import { useState, useEffect, useRef } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { todayDate, maxDate } from "../utility/common/helpers/TodayDate";
import { AddNewWelder, UpdateWelder, getPresignedURL } from "../../Services/Welder-services";
import { getPEDUsers } from "../../Services/user-service";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import {
  islessthenMaxlength,
  isNumber,
  isAlphanumericWithDashDot,
  isAlphanumericWithSpaceDotDash, isAlphanumericWithDotSpaceDashCommaBrackets, isAlphanumericWithDotSpaceDashCommaBracketsemail
} from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import defaultimg from "../../icons/user.png";
import WelderProfileCellRenderer from "../utility/grid/definitions/AgGridDefination";
import axios from "axios";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import ButtonModal from "../Modals/buttonModal";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { normalstyle, errorstyle } from "../../functions/welding-functions";

// Helper functions
const normalizeStatus = (rowdata) => {
  const normalizedData = { ...rowdata };
  normalizedData.wld_status = rowdata.wld_status === "Active";
  return normalizedData;
};

const createInitialWelderObj = () => ({
  wld_status: true,
  wld_code: "",
  wld_name: "",
  wld_salarycode: "",
  wld_dob: todayDate,
  wld_companyname: "",
  wld_plant: "",
  wld_address: "",
  wld_city: "",
  wld_state: "",
  wld_pincode: "",
  wld_country: "",
  wld_language: "",
  wld_mobile: "",
  wld_fax: "",
  wld_telephone: "",
  wld_email: "",
  SK: "",
  PK: "Welder",
  wld_createdby: "",
  wld_createdon: "",
  wld_updatedby: "",
  wld_updatedon: "",
  wld_profile: "",
});

const AddEditWelderMaster = (props) => {
  const normalizedRowData = normalizeStatus(props.rowdata);
  const action = props.action;
  const formName = "Welder";
  const folderName = "wld_signatures";
  const checked = true;
  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [Welder, setWelder] = useState([]);
  const [WelderCode, setWelderCode] = useState(false);
  const [profile, setProfile] = useState("");
  const toggle = normalizedRowData?.wld_status === false ? "InactiveToggleLabel" : "activeToggleLabel";
  const [toggleClass, setToggleClass] = useState(action === "Edit" ? toggle : "activeToggleLabel");

  const fetchWelder = async () => {
    const result = await getPEDUsers();
    setWelder(result);
  };
  useEffect(() => {
    fetchWelder();
  }, []);

  const history = useNavigate();
  const username = sessionStorage.getItem("UserName");

  const [WelderObj, setWelderObj] = useState(
    action === "Edit" ? normalizedRowData : createInitialWelderObj()
  );


  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_language: {},
    wld_address: {},
    wld_city: {},
    wld_state: {},
    wld_pincode: {},
    wld_country: {},
    wld_mobile: {},
    wld_fax: {},
    wld_email: {},
    wld_telephone: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
    wld_name: {},
    wld_salarycode: {},
    wld_dob: {},
    wld_companyname: {},
    wld_plant: {},
    wld_profile: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setWelder",
    });
  };



  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setWelderObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
      wld_salarycode: {},
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }
    setWelderObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const userProfiles = [];
  const fileInputRef = useRef(null);
  const avatar = { defaultimg };
  const [previewUrl, setPreviewUrl] = useState(avatar.defaultimg);
  const handleOndragOver = (event) => {
    event.preventDefault();
  };

  const validateFileSize = (file) => {
    const maxSize = 1 * 1024 * 1024;
    return file.size <= maxSize;
  };

  const validateFileType = (file) => {
    const allowedTypes = ["jpeg", "png", "jpg"];
    const extension = file.name.split(".")[1];
    return allowedTypes.includes(extension);
  };

  const handleFile = (file) => {
    if (!validateFileSize(file)) {
      alert("File size exceeds the allowed limit. Add File Less Than 1 Mb");
      return;
    }

    if (!validateFileType(file)) {
      alert("Please Upload Jpeg,png or jpg images");
      return;
    }

    setProfile(file);
    setPreviewUrl(URL.createObjectURL(file));
    WelderObj.wld_profile = file.name;
  };

  const resetAddForm = () => {
    setWelderObj(createInitialWelderObj());
    setPreviewUrl(defaultimg);
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  const resetEditForm = () => {
    setWelderObj(normalizedRowData);
  };

  const clearErrors = () => {
    const clearedErrors = Object.keys(error).reduce((acc, key) => {
      acc[key] = {};
      return acc;
    }, {});
    setError(clearedErrors);
  };

  const resetForm = () => {
    if (action === "Add") {
      resetAddForm();
    } else {
      resetEditForm();
    }
    clearErrors();
  };

  const validateEmail = () => {
    const email = WelderObj.wld_email;
    if (email && (!email.includes("@") || !email.includes("."))) {
      WelderObj.wld_email = "";
      error.wld_email = {
        status: true,
        message: "Welder Email @ and . is required. Eg: john@godrej.com",
      };
      return true;
    }
    return false;
  };

  const validateStatus = () => {
    if (WelderObj.wld_status === "") {
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
      return true;
    }
    return false;
  };

  const hasFieldErrors = () => {
    const errorFields = [
      'SK', 'wld_code', 'wld_address', 'wld_city', 'wld_state', 'wld_pincode',
      'wld_country', 'wld_language', 'wld_mobile', 'wld_fax', 'wld_telephone',
      'wld_email', 'wld_salarycode', 'wld_companyname', 'wld_name', 'wld_dob', 'wld_plant'
    ];
    return errorFields.some(field => error[field]?.status);
  };

  const validateWelder = () => {
    let isError = validateEmail() || validateStatus();

    setError((prevState) => ({
      ...prevState,
      ...error,
    }));

    return isError || hasFieldErrors();
  };

  const prepareWelderData = () => {
    if (WelderObj.wld_status === true) {
      WelderObj.wld_status = "Active";
    } else {
      WelderObj.wld_status = "Inactive";
    }

    if (action === "Add") {
      WelderObj.wld_code = WelderObj.wld_code || "";
      WelderObj.status = "Active";
      WelderObj.SK = WelderObj.wld_code || WelderObj.wld_email;
      WelderObj.wld_createdby = username;
      return AddNewWelder(WelderObj);
    } else {
      WelderObj.wld_updatedby = WelderObj.wld_createdby || "";
      return UpdateWelder(WelderObj);
    }
  };

  const handleProfileUpload = async () => {
    if (WelderObj.wld_profile) {
      const result = await getPresignedURL(folderName, WelderObj.wld_profile);
      const posturl = result.url;
      setPreviewUrl(posturl);
      axios.put(posturl, profile);
    }
  };

  const showSuccessMessage = (resp) => {
    if (resp.message === "Duplicate") {
      showWarning(resp.message);
    } else {
      const message = action === "Edit"
        ? "Selected Welder has been Updated successfully"
        : "Selected Welder has been Added successfully";
      showSuccess(message);
    }
  };

  const closeModal = () => {
    props.setReload(!props.reload);
    setShowForm(false);
    props.onHide();
  };

  const handleAdd = async () => {
    const result = prepareWelderData();

    try {
      const resp = await result;
      await handleProfileUpload();
      showSuccessMessage(resp);
      closeModal();
    } catch (error) {
      showWarning("Selected Welder has failed");
      closeModal();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateWelder()) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  const fetchUserProfiles = async () => {
    try {
      if (WelderObj.wld_profile !== "") {
        const result = await getPresignedURL(folderName, WelderObj.wld_profile);
        const geturl = result.url;
        setPreviewUrl(geturl);
      }
    } catch (error) {
      if (error.request) {
        console.log(error.request);
      } else {
        console.log(`Error: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    fetchUserProfiles();
  }, []);

  const handleOndrop = (event) => {
    let imageFile = event.dataTransfer.files[0];
    handleFile(imageFile);
  };

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Welder successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />

      <Modal
        {...props}
        size="lg"
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header className="modal_heading" closeButton>
          <Modal.Title>{action} New Welder</Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={handleSubmit}
          autoComplete="off"
          encType="multipart/form-data"
        >
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={8} sm={2}>
                  <Form.Group>
                    <form encType="multipart/form-data">
                      <div className="welder-pic-upload">
                        <img src={previewUrl} className="welder-circle" />
                        <WelderProfileCellRenderer src={userProfiles} />
                        <div
                          className="welder-drop-zone"
                          onDragOver={handleOndragOver}
                          onDrop={handleOndrop}
                        >
                          <div>
                            <Form.Label className="welder-pic-text-black" htmlFor="fileInput" style={{ display: 'inline' }}>
                              Drop your photo here or{" "}
                            </Form.Label>
                            <Form.Label className="welder-pic-text-blue" htmlFor="fileInput" style={{ display: 'inline' }}>
                              Select a file
                            </Form.Label>
                          </div>
                          <Form.Label className="welder-pic-text-weld" style={{ fontFamily: 'GE-BodyCopy, sans-serif', fontSize: '12px', lineHeight: '14px', fontWeight: 'normal' }}>
                            Supports: Jpeg, PNG and JPG, Size:Max 1MB
                          </Form.Label>
                          <Form.Label className="welder-pic-text-optional">
                            (Optional)
                          </Form.Label>
                          <Form.Label className="welder-imgtext">
                            {WelderObj.wld_profile}
                          </Form.Label>
                          <input
                            id="fileInput"
                            name="fileInput"
                            type="file"
                            accept="image/*"
                            hidden
                            ref={fileInputRef}
                            onChange={(e) => handleFile(e.target.files[0])}
                          />
                        </div>
                      </div>
                    </form>
                    &nbsp;&nbsp;
                  </Form.Group>
                </Col>
                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={WelderObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {WelderObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group>
                    <div className="checkboxproject">
                      <input
                        type="checkbox"
                        placeholder=" "
                        className="form-check-input"
                        id="chkcode"
                        onClick={() => {
                          setWelderCode(!WelderCode);
                          resetForm();
                        }}
                        disabled={action === "Edit"}
                        defaultChecked={!checked}
                      />{" "}
                      &nbsp;&nbsp;
                      <Form.Label htmlFor="chkcode">Contractor </Form.Label>
                    </div>
                    &nbsp;&nbsp;
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        maxLength="50"
                        required
                        disabled={
                          action === "Edit" || WelderCode === false
                        }
                        className={
                          error.wld_code.status
                            ? " w-input placeHolderInput inputText text-field-with-error allow"
                            : "w-input placeHolderInput inputText allow"
                        }
                        value={WelderObj.wld_code || ""}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithDashDot(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        Welder Code{" "}
                      </Form.Label>
                      {error.wld_code.status && (
                        <Form.Text className="text-danger">
                          {error.wld_code.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="pro-input-select">
                    <div className="search-select">
                      <SearchSelect
                        id="wld_salarycode"
                        name="wld_salarycode"
                        className={
                          error.wld_salarycode.status ? "err-input" : ""
                        }
                        stylegreen={
                          error.wld_salarycode.status ? errorstyle : normalstyle
                        }
                        data={Welder}
                        valueField={"empSalCode"}
                        disabled={
                          action === "Edit" || WelderCode === true
                        }
                        value={WelderObj?.wld_salarycode || ""}
                        labelField1={"empSalCode"}
                        labelField2={"empshortName"}
                        placeholder=""
                        onChange={(ItemList) => {
                          let a = Welder.filter((b) => {
                            return b.empSalCode === ItemList.value;
                          });
                          setWelderObj((prev) => ({
                            ...prev,
                            wld_salarycode: a[0].empSalCode,
                            wld_name: a[0].empshortName,

                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label>Salary Code</Form.Label>
                    <div className="required-text-select">
                      {error.wld_salarycode.status && (
                        <Form.Text className="text-danger">
                          {error.wld_salarycode.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: "0.5rem" }}>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_name"
                        name="wld_name"
                        type="text"
                        disabled={
                          action === "Edit" || WelderCode === false
                        }
                        maxLength="50"
                        required
                        className={`asterisk ${error.wld_name.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_name}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithSpaceDotDash(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            wld_name: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_name">
                        Name
                      </Form.Label>
                      {error.wld_name.status && (
                        <Form.Text className="text-danger">
                          {error.wld_name.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_companyname"
                        name="wld_companyname"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_companyname.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_companyname || ""}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_companyname: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_companyname">Company Name</Form.Label>
                      {error.wld_companyname.status && (
                        <Form.Text className="text-danger">
                          {error.wld_companyname.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_plant"
                        name="wld_plant"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_plant.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_plant || ""}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_plant: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_plant">Plant</Form.Label>
                      {error.wld_plant.status && (
                        <Form.Text className="text-danger">
                          {error.wld_plant.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: "0.5rem" }}>
                <Col md={4}>
                  <DateInput
                    divClass="T-input w-100"
                    label="DOB"
                    className="groove_datecolor"
                    name="wld_dob"
                    todayDate={todayDate}
                    maxDate={maxDate}
                    obj={WelderObj}
                    setobj={setWelderObj}
                    setError={setError}
                    status={error.wld_dob.status}
                    message={error.wld_dob.message}
                  />
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_address"
                        name="wld_address"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_address.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_address || ""}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_address: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_address">Address</Form.Label>
                      {error.wld_address.status && (
                        <Form.Text className="text-danger">
                          {error.wld_address.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_city"
                        name="wld_city"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_city.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_city}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_city: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_city">City</Form.Label>
                      {error.wld_city.status && (
                        <Form.Text className="text-danger">
                          {error.wld_city.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: "0.5rem" }}>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_state"
                        name="wld_state"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_state.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_state}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_state: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_state">State</Form.Label>
                      {error.wld_state.status && (
                        <Form.Text className="text-danger">
                          {error.wld_state.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_pincode"
                        name="wld_pincode"
                        type="text"
                        maxLength="6"
                        className={`asterisk ${error.wld_pincode.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_pincode}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_pincode: error,
                          }));

                          if (!error.status) {
                            error = islessthenMaxlength(e, "Pincode");
                            setError((prevState) => ({
                              ...prevState,
                              wld_pincode: error,
                            }));
                          }
                        }}
                      />
                      <Form.Label htmlFor="wld_pincode">Pincode</Form.Label>
                      {error.wld_pincode.status && (
                        <Form.Text className="text-danger">
                          {error.wld_pincode.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_country"
                        name="wld_country"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_country.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_country}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_country: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_country">Country</Form.Label>
                      {error.wld_country.status && (
                        <Form.Text className="text-danger">
                          {error.wld_country.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: "0.5rem" }}>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_language"
                        name="wld_language"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_language.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_language}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_language: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_language">Language</Form.Label>
                      {error.wld_language.status && (
                        <Form.Text className="text-danger">
                          {error.wld_language.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_mobile"
                        name="wld_mobile"
                        type="text"
                        maxLength="10"
                        className={`asterisk ${error.wld_mobile.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_mobile}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_mobile: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_mobile">Mobile</Form.Label>
                      {error.wld_mobile.status && (
                        <Form.Text className="text-danger">
                          {error.wld_mobile.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_fax"
                        name="wld_fax"
                        type="text"
                        maxLength="20"
                        className={`asterisk ${error.wld_fax.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_fax}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_fax: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_fax">Fax</Form.Label>
                      {error.wld_fax.status && (
                        <Form.Text className="text-danger">
                          {error.wld_fax.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: "0.5rem" }}>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_telephone"
                        name="wld_telephone"
                        type="text"
                        maxLength="12"
                        className={`asterisk ${error.wld_telephone.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WelderObj.wld_telephone}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_telephone: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_telephone">Telephone</Form.Label>
                      {error.wld_telephone.status && (
                        <Form.Text className="text-danger">
                          {error.wld_telephone.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="w-input">
                      <input
                        id="wld_email"
                        name="wld_email"
                        type="text"
                        maxLength="50"
                        className={
                          error.wld_email.status
                            ? "placeHolderInput inputText text-field-with-error allow"
                            : "placeHolderInput inputText allow"
                        }
                        placeholder=" "
                        value={WelderObj.wld_email}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBracketsemail(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_email: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_email">Email ID</Form.Label>
                      {error.wld_email.status && (
                        <Form.Text className="text-danger">
                          {error.wld_email.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>

    </>
  );
};

export default AddEditWelderMaster;